import { Icon, ICON_VARIANTS } from 'components/Icon'
import { InputElement } from '../styles'
import { SearchInputContainer, SearchInputIconWrapper } from './styles'
import { SearchInputProps } from './types'

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  size = 'lg',
  placeholder = 'Search...',
  onKeyUp,
  transparent,
  attach,
}) => {
  return (
    <SearchInputContainer transparent={transparent} size={size} attach={attach}>
      <SearchInputIconWrapper>
        <Icon variant={ICON_VARIANTS.magnifyGlass} />
      </SearchInputIconWrapper>
      <InputElement
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onKeyUp={onKeyUp}
        transparent={transparent}
      />
    </SearchInputContainer>
  )
}
